import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';

export const PAYMENT_METHODS_RECEIVE = 'PAYMENT_METHODS_RECEIVE';
export const PAYMENT_METHODS_ERROR = 'PAYMENT_METHODS_ERROR';
export const PAYMENT_METHODS_ADDED = 'PAYMENT_METHODS_ADDED';

const rootRoute = 'api/erp/paymentMethods';

export const receive = (data) => ({
    type: PAYMENT_METHODS_RECEIVE,
    payload: {
        list: data,
        paymentMethodsLoaded: true,
    },
});

export const setError = (error) => ({
    type: PAYMENT_METHODS_ERROR,
    payload: {
        error,
    },
});

export const paymentMethodHasBeenAdded = (value) => ({
    type: PAYMENT_METHODS_ADDED,
    payload: value,
});

export const getPaymentMethods = () => (dispatch) => {
    dispatch(showLoader());
    return get(rootRoute)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const deleteMethod = (type, timestamp, guid1, guid2) => (dispatch) => {
    dispatch(showLoader());
    return post(rootRoute + '/delete', { type, timestamp, guid1, guid2 })
        .then(() => dispatch(getPaymentMethods()))
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const setDefault = (type, timestamp, guid1, guid2) => (dispatch) => {
    dispatch(showLoader());
    return post(rootRoute + '/setDefault', { type, timestamp, guid1, guid2 })
        .then(() => {
            dispatch(getPaymentMethods());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const addAch = (ach) => (dispatch) => {
    // Empty error list
    dispatch(setError({ errors: '' }));

    // Business account is default
    if (ach.isBusinessAccount == undefined) ach.isBusinessAccount = true;

    // End point defines what fields are error checked
    var specificEndpoint = '/addPersonalAch';
    if (ach.isBusinessAccount) specificEndpoint = '/addBusinessAch';

    dispatch(showLoader());
    return post(rootRoute + specificEndpoint, ach)
        .then(() => {
            dispatch(getPaymentMethods());
            dispatch(paymentMethodHasBeenAdded(true));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const addCard = (card) => (dispatch) => {
    // Empty error list
    dispatch(setError({ errors: '' }));

    dispatch(showLoader());
    return post(rootRoute + '/addCard', card)
        .then(() => {
            dispatch(getPaymentMethods());
            dispatch(paymentMethodHasBeenAdded(true));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};
